import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7e33336"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "draft-watermark"
}
const _hoisted_2 = {
  key: 1,
  class: "draft-banner"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "draft-banner-text" }, "PISZKOZAT — AZ ÜGYFÉL NEM LÁTJA", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-2 mb-1" }, "Lemondási feltételek", -1))
const _hoisted_5 = { class: "text-body-2 text-medium-emphasis cancellation-policy-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-2 mb-1" }, "Megjegyzés", -1))
const _hoisted_7 = { class: "text-body-2 text-medium-emphasis cancellation-policy-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, {
      class: _normalizeClass(["v-card--variant-outlined", { 'draft-card': _ctx.isDraft }])
    }, {
      default: _withCtx(() => [
        (_ctx.isDraft)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, "PISZKOZAT"))
          : _createCommentVNode("", true),
        (_ctx.isDraft)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_icon, {
                class: "mr-2",
                icon: "mdi-lock-outline"
              }),
              _hoisted_3,
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_checkbox, {
                "model-value": _ctx.selected,
                "onUpdate:modelValue": _ctx.onSelectionChange,
                density: "compact",
                "hide-details": "",
                color: "white",
                label: "Kiválasztás küldéshez"
              }, null, 8, ["model-value", "onUpdate:modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_data_table, {
          items: _ctx.offer.items,
          headers: _ctx.headers,
          "hide-default-footer": true,
          hover: ""
        }, {
          top: _withCtx(() => [
            _createVNode(_component_v_toolbar, {
              flat: "",
              height: "56",
              color: "transparent"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_toolbar_title, { class: "text-left" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(`Ajánlat ${_ctx.offer.items[0]?.accommodation} szálláshelyre`), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                (_ctx.isDraft)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_v_btn, {
                        class: "mr-2",
                        color: "warning",
                        variant: "outlined",
                        size: "small",
                        onClick: _ctx.onEditClicked
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            class: "mr-1",
                            icon: "mdi-pencil-outline",
                            size: "small"
                          }),
                          _createTextVNode("Szerkesztés")
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_v_btn, {
                        class: "mr-2",
                        color: "warning",
                        variant: "flat",
                        size: "small",
                        onClick: _ctx.openPublishConfirm
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            class: "mr-1",
                            icon: "mdi-send",
                            size: "small"
                          }),
                          _createTextVNode("Küldés")
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_v_btn, {
                        color: "error",
                        variant: "text",
                        size: "small",
                        onClick: _ctx.openDeleteConfirm
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            class: "mr-1",
                            icon: "mdi-delete-outline",
                            size: "small"
                          }),
                          _createTextVNode("Törlés")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_v_chip, {
                        class: "mr-2",
                        color: _ctx.statusColor,
                        variant: "flat",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.offerStatusLabel(_ctx.offer.status)), 1)
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      (!_ctx.acceptable)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            bottom: ""
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
                                _createVNode(_component_v_btn, {
                                  color: "success",
                                  variant: "flat",
                                  size: "small",
                                  disabled: true,
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openConfirm(_ctx.offer.id)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Ajánlat elfogadása")
                                  ]),
                                  _: 1
                                })
                              ], 16)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.blockedReason), 1)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            color: "success",
                            variant: "flat",
                            size: "small",
                            disabled: false,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openConfirm(_ctx.offer.id)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Ajánlat elfogadása")
                            ]),
                            _: 1
                          }))
                    ], 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["items", "headers"]),
        (_ctx.offer.cancellationPolicy)
          ? (_openBlock(), _createBlock(_component_v_card_text, { key: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_divider, { class: "mb-3" }),
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.offer.cancellationPolicy), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.offer.comment)
          ? (_openBlock(), _createBlock(_component_v_card_text, { key: 3 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_divider, { class: "mb-3" }),
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.offer.comment), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showConfirm,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showConfirm) = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode("Biztosan elfogadja az ajánlatot?")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  text: "",
                  color: "grey",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showConfirm = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Mégse")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "success",
                  onClick: _ctx.confirmAccept
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Igen, elfogadom")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showPublishConfirm,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showPublishConfirm) = $event)),
      "max-width": "460"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Ajánlat küldése az ügyfélnek")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode("Az ajánlat ezzel láthatóvá válik az ügyfél számára. Biztosan elküldi?")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  text: "",
                  color: "grey",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showPublishConfirm = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Mégse")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "warning",
                  variant: "flat",
                  onClick: _ctx.confirmPublish
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Igen, küldés")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showDeleteConfirm,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showDeleteConfirm) = $event)),
      "max-width": "460"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Piszkozat törlése")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode("A piszkozat véglegesen törlésre kerül. Biztosan törli?")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  text: "",
                  color: "grey",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showDeleteConfirm = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Mégse")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "error",
                  variant: "flat",
                  onClick: _ctx.confirmDelete
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Igen, törlés")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}